/* eslint-disable */

import { createWebHistory, createRouter } from "vue-router";
import Store from "../store";
import auth from "../app/auth";
import UserInfoStore from "../app/user-info-store";
import UserInfoApi from "../app/user-info-api";
import ErrorComponent from "@/components/Error";

var Page = [
  "DealCreate",
  "SiteCreate",
  "Performance",
  "VisitRatio",
  "MyAmbassadors",
  "MyFriends",
];

function requireAuth(to, from, next) {
  // console.log(auth, "auth1");
  if (!auth.auth.isUserSignedIn()) {
    UserInfoStore.setLoggedIn(false);
    next({
      path: "/login",
      query: { redirect: to.fullPath },
    });
  } else {
    const _userInfo = Store.state.cognitoInfo;
    if (_userInfo && _userInfo.displayname && _userInfo.username) {
      UserInfoApi.getUserDetailsAPICall(
        _userInfo.email,
        _userInfo.username
      ).then((response) => {
        UserInfoStore.setLoggedIn(true);
        Store.commit("setCognitoInfo", response);
        if (
          (to.name == "DealCreate" ||
            to.name == "SiteCreate" ||
            to.name == "Performance" ||
            to.name == "VisitRatio" ||
            to.name == "MyAmbassadors" ||
            to.name == "MyFriends") &&
          _userInfo.companyid == "_all"
        ) {
          // Vue.prototype.$alert(
          //   "Warning|Please select any company other than All"
          // );
          if (from.name == null) {
            next({
              name: "Home",
            });
          }
        } else {
          next();
        }
      });
    } else {
      UserInfoApi.getUserInfo().then((response) => {
        UserInfoStore.setLoggedIn(true);
        Store.commit("setCognitoInfo", response);
        if (
          (to.name == "DealCreate" ||
            to.name == "SiteCreate" ||
            to.name == "Performance" ||
            to.name == "VisitRatio" ||
            to.name == "MyAmbassadors" ||
            to.name == "MyFriends") &&
          _userInfo.companyid == "_all"
        ) {
          // Vue.alert("Warning|Please select any company other than All");
          if (from.name == null) {
            next({
              name: "Home",
            });
          }
        } else {
          next();
        }
      });
    }
  }
}

const routes = [
  {
    path: Store.getters.GetRoutePath("home"),
    name: "Home",
    //component: () => import("../views/Home.vue"),
    component: () => import("../views/Dashboard/Dashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("sitelist"),
    name: "SiteList",
    component: () => import("../views/Site/Site.vue"),
  },
  {
    path: Store.getters.GetRoutePath("sitecreate"),
    name: "SiteCreate",
    component: () => import("../views/Site/Create.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("siteedit"),
    name: "SiteEdit",
    component: () => import("../views/Site/Create.vue"),
    beforeEnter: requireAuth,
  },

  {
    path: Store.getters.GetRoutePath("sitecopy"),
    name: "SiteCopy",
    component: () => import("../views/Site/Create.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("siteChangelog"),
    name: "SiteChangelog",
    component: () => import("../views/Reports/SiteChangelog.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("deallist"),
    name: "DealList",
    component: () => import("../views/Deal/List.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("dealcreate"),
    name: "DealCreate",
    component: () => import("../views/Deal/Create.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("dealedit"),
    name: "DealEdit",
    component: () => import("../views/Deal/Edit.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("performance"),
    name: "Performance",
    component: () => import("../views/Reports/Performance.vue"),
  },
  {
    path: Store.getters.GetRoutePath("myambassadors"),
    name: "Ambassadors",
    component: () => import("../views/Reports/MyAmbassadors.vue"),
  },
  {
    path: Store.getters.GetRoutePath("myfriends"),
    name: "Friends",
    component: () => import("../views/Reports/MyFriends.vue"),
  },

  {
    path: Store.getters.GetRoutePath("relations"),
    name: "Relations",
    component: () => import("../views/Reports/Relations.vue"),
  },
  {
    path: Store.getters.GetRoutePath("companylist"),
    name: "CompanyList",
    component: () => import("../views/Company/List.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("companycreate"),
    name: "CompanyCreate",
    component: () => import("../views/Company/Create.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("companyedit"),
    name: "CompanyEdit",
    component: () => import("../views/Company/Create.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("changelog"),
    name: "Changelog",
    component: () => import("../views/Reports/Changelog.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("userlist"),
    name: "UserList",
    component: () => import("../views/User/User.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("usercreate"),
    name: "UserCreate",
    component: () => import("../views/User/CreateUser.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("useredit"),
    name: "UserEdit",
    component: () => import("../views/User/CreateUser.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("updatetranslation"),
    name: "Translation",
    component: () => import("../views/Translation/Translation.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("contactlist"),
    name: "FailedContact",
    component: () => import("../views/Contact/List.vue"),
  },
  {
    path: Store.getters.GetRoutePath("errorsummary"),
    name: "Error",
    component: () => import("../views/Contact/ErrorSummary.vue"),
  },
  {
    path: Store.getters.GetRoutePath("managedeallist"),
    name: "ManageDealList",
    component: () => import("../views/ManageDeals/List.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("editdeal"),
    name: "EditDeal",
    component: () => import("../views/UpdateDeal/Update.vue"),
    beforeEnter: requireAuth,
  },    
  {
    path: Store.getters.GetRoutePath("copydeal"),
    name: "CopyDeal",
    component: () => import("../views/UpdateDeal/Update.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("dealsearch"),
    name: "DealSearch",
    component: () => import("../views/Reports/DealSearch.vue"),
    beforeEnter: requireAuth,
  },

  {
    path: "/login",
    name: "Login",
    beforeEnter() {
      // console.log(auth.auth.getSession(), 'auth.auth.getSession()')
      auth.auth.getSession();
    },
  },
  {
    path: "/login/oauth2/code/cognito",
    name: "LoginCognito",
    beforeEnter() {
      var currUrl = window.location.href;
      auth.auth.parseCognitoWebResponse(currUrl);
    },
  },
  {
    path: "/error",
    component: ErrorComponent,
  },
  {
    path: "/logout",
    name: "Logout",
    beforeEnter(to, from, next) {
      // console.log(auth,876);
      auth.logout();
      next("/");
    },
  },
  
  {
    path: "/:catchAll(.*)",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(),
  // base:"/",
  routes,
});

router.beforeEach((to) => {
  Store.commit("setActiveRoute", to.meta.module);
});

export default router;
